import axios from 'axios';

export default {
  namespaced: true,
  state: {
    replyRuleForm: {
      name: '',
      qrids: '',
      texts: '',
      msgType: '2',
      qrNames: ''
    },
    areaNum: 0,
    updateId: '',
    nameAreaNum: 0
  },
  mutations: {
    replyRuleValidate(state, { list }) {
      if (list) {
        let { ruleName, replyContent, msgType, qrcodeIds, qrcodeNames } = list;
        state.replyRuleForm.name = ruleName;
        state.replyRuleForm.texts = replyContent;
        state.replyRuleForm.msgType = String(msgType);
        state.replyRuleForm.qrids = qrcodeIds;
        state.replyRuleForm.qrNames = qrcodeNames;
        if (list.replyContent) {
          state.areaNum = String(replyContent).length;
        } else {
          state.areaNum = 0;
        }
        if (list.ruleName) {
          state.nameAreaNum = String(ruleName).length;
        } else {
          state.nameAreaNum = 0;
        }
      } else {
        state.replyRuleForm = {
          name: '',
          qrids: '',
          texts: '',
          msgType: '2',
          qrNames: ''
        };
      }
    },
    setAreaNum(state, value) {
      state.areaNum = value;
    },
    setUpdateId(state, value) {
      state.updateId = value;
    },
    setNameAreaNum(state, value) {
      state.nameAreaNum = value;
    },

  },
  actions: {
    createScanReplyRule({ commit }, params) {
      return axios.post('/wxnews/ajax/createScanReplyRule', params).then((data) => {
        return data;
      });
    },
    getScanReplyRule({ commit }, params) {
      return axios.get('/wxnews/ajax/getScanReplyRule', {
        params: params,
      }).then((data) => {
        commit({ type: 'replyRuleValidate', list: data.data });
        return data;
      },
      rej => {
      });
    },
    updateScanReplyRule({ commit }, params) {
      return axios.post('/wxnews/ajax/updateScanReplyRule', params).then((data) => {
        return data;
      });
    },
    qrcodeList({ commit }, params) {
      return axios.get('/wxnews/ajax/qrcodeList', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    isBindRuleForQrcode({ commit }, params) {
      return axios.get('/wxnews/ajax/isBindRuleForQrcode', {
        params: params,
      }).then((data) => {
        return data;
      });
    }
  }
};
